// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"9323c259","193":"fd6becc3","239":"5f144102","277":"021be5d1","287":"d7b0f57c","455":"140bc885","500":"91a87590","525":"aa5324a1","608":"50fa6866","977":"68932f2c","996":"aee9d8a7"}[chunkId] + ".chunk.js";
};